import { produce } from "immer";
import {
    BONUSES_SET_ACTIVE_SUCCESS,
    BONUSES_SET_AVAILABLE,
    CHECK_BONUS_PROMOCODE_FAILURE,
    CHECK_BONUS_PROMOCODE_START,
    CHECK_BONUS_PROMOCODE_SUCCESS,
    CLEAR_BONUS_PROMOCODE,
    CLEAR_BONUSES,
    GET_NEW_LIFE_ACCOUNTS_FAILURE,
    GET_NEW_LIFE_ACCOUNTS_START,
    GET_NEW_LIFE_ACCOUNTS_SUCCESS,
    SET_ACTIVE_PROMOCODES_FAILURE,
    SET_ACTIVE_PROMOCODES_START,
    SET_ACTIVE_PROMOCODES_SUCCESS,
    SET_BONUS_PROMOCODE,
    SET_NEW_LIFE_RESPAWN_BANNER_OPENED,
    SET_NEW_LIFE_RESPAWN_FAILURE,
    SET_NEW_LIFE_RESPAWN_START,
    SET_NEW_LIFE_RESPAWN_SUCCESS,
    SET_USED_PROMOCODES_START,
    SET_WELCOME_APPLY_BONUS,
    SET_WELCOME_BANNER_OPENED
} from "./bonusesConstants";
import { IBonusesAction } from "./types/bonusesActions";
import { IBonusesState } from "./types/bonusesReducer";
import _ from "lodash";
import Cookies from 'universal-cookie';

const browserCookies = new Cookies();

const initialState: IBonusesState = {
    bonusesActiveList: [],
    bonusesAvailableList: [],

    promocode: '',
    promocodeError: null,
    promocodeIsLoading: false,

    activePromocodes: [],
    activePromocodesError: null,
    activePromocodesIsLoading: false,

    usedPromocodes: [],

    welcomeApplyBonus: false,
    welcomeBannerOpened: true,

    newLifeAccounts: [],
    newLifeAccountsError: null,
    newLifeAccountsIsLoading: false,

    newLifeRespawnError: null,
    newLifeRespawnInProgress: false,
    newLifeRespawnSuccess: false,
    newLifeRespawnBannerOpened: true,

    respawnBannerPortfolioOpened: !browserCookies.get('respawn_portfolio_closed'),
    respawnBannerProfileOpened: !browserCookies.get('respawn_profile_closed'),
};

const bonusesReducer = (state: IBonusesState = initialState, action: IBonusesAction) =>
    produce(state, (draft: IBonusesState) => {
        switch (action.type) {

            case CLEAR_BONUSES:
                return { ...initialState };

            case BONUSES_SET_ACTIVE_SUCCESS:
                const parsedBonusesActiveList = _.map(action.payload || [], (bonus) => ({
                    ...bonus,
                    amount: +bonus.amount,
                    credit: +bonus.credit,
                    current_lots_amount: +bonus.current_lots_amount,
                    total_lots_amount: +bonus.total_lots_amount,
                }));
                draft.bonusesActiveList = parsedBonusesActiveList;
                break;

            case BONUSES_SET_AVAILABLE:
                draft.bonusesAvailableList = action.payload || [];
                break;

            case SET_WELCOME_APPLY_BONUS:
                draft.welcomeApplyBonus = action.payload;
                break;

            case SET_WELCOME_BANNER_OPENED:
                draft.welcomeBannerOpened = action.payload;
                break;

            case GET_NEW_LIFE_ACCOUNTS_START:
                draft.newLifeAccountsError = null;
                draft.newLifeAccountsIsLoading = true;
                break;
            case GET_NEW_LIFE_ACCOUNTS_SUCCESS:
                draft.newLifeAccounts = action.payload || [];
                draft.newLifeAccountsIsLoading = false;
                break;
            case GET_NEW_LIFE_ACCOUNTS_FAILURE:
                draft.newLifeAccountsError = null;
                draft.newLifeAccountsIsLoading = false;
                break;

            case SET_NEW_LIFE_RESPAWN_START:
                draft.newLifeRespawnError = null;
                draft.newLifeRespawnInProgress = true;
                draft.newLifeRespawnSuccess = false;
                break;
            case SET_NEW_LIFE_RESPAWN_SUCCESS:
                draft.newLifeRespawnInProgress = false;
                draft.newLifeRespawnSuccess = true;
                break;
            case SET_NEW_LIFE_RESPAWN_FAILURE:
                draft.newLifeRespawnError = action.payload;
                draft.newLifeRespawnInProgress = false;
                break;
            case SET_NEW_LIFE_RESPAWN_BANNER_OPENED:
                if (action.payload.source === 'profile') {
                    draft.respawnBannerProfileOpened = action.payload.opened;
                } else if (action.payload.source === 'portfolio') {
                    draft.respawnBannerPortfolioOpened = action.payload.opened;
                } else {
                    draft.newLifeRespawnBannerOpened = action.payload.opened;
                }
                break;

            case CHECK_BONUS_PROMOCODE_START:
                draft.promocodeError = null;
                draft.promocodeIsLoading = true;
                break;
            case CHECK_BONUS_PROMOCODE_SUCCESS:
                draft.promocode = action.payload.toLowerCase();
                draft.promocodeIsLoading = false;
                break;
            case CHECK_BONUS_PROMOCODE_FAILURE:
                draft.promocodeError = action.payload;
                draft.promocodeIsLoading = false;
                break;

            case CLEAR_BONUS_PROMOCODE:
                draft.promocode = '';
                draft.promocodeError = null;
                draft.promocodeIsLoading = false;
                break

            case SET_BONUS_PROMOCODE:
                draft.promocode = action.payload.toLowerCase();
                break

            case SET_ACTIVE_PROMOCODES_START:
                draft.activePromocodesError = null;
                draft.activePromocodesIsLoading = true;
                break;
            case SET_ACTIVE_PROMOCODES_SUCCESS:
                draft.activePromocodes = action.payload;
                draft.activePromocodesIsLoading = false;
                break;
            case SET_ACTIVE_PROMOCODES_FAILURE:
                draft.activePromocodesError = action.payload;
                draft.activePromocodesIsLoading = false;
                break;

            case SET_USED_PROMOCODES_START:
                draft.usedPromocodes = action.payload;
                break;
            default:
                return state;
        }
    });

export default bonusesReducer;
